<template>
	<div class="short-link-page container">
		<section class="page-hero">
			<div>
				<p>LINK CENTER</p>
				<h2>目标域名地址</h2>
				<span>管理目标跳转规则，中间域名自动轮询，最终目标地址按权重分流。</span>
			</div>
			<i class="el-icon-connection" />
		</section>
		<el-card class="short-link-card" shadow="never">
			<div class="content-heading">
				<div>
					<h3>目标规则</h3>
					<p>入口域名按分组轮询后台域名；同一 IP 会固定命中同一规则 24 小时，之后按权重重新分配。今日 PV / UV 仅统计当天，和统计页的历史汇总 UV 口径不同。</p>
				</div>
				<el-tag type="info" effect="plain">{{ total }} 条规则</el-tag>
			</div>
			<div class="filter-container">
				<el-select v-model="listQuery.domain_group_id" clearable filterable placeholder="全部分组" @change="getList"><el-option v-for="item in groups" :key="item.id" :label="item.name" :value="item.id"/></el-select><el-input v-model.trim="listQuery.target_url" clearable placeholder="搜索最终目标地址" prefix-icon="el-icon-search" @keyup.enter.native="getList" /><el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button
				><el-button type="success" icon="el-icon-plus" @click="handleEdit()">新增规则</el-button>
			</div>
			<el-table v-loading="listLoading" :data="list" class="allocation-table" :height="height" empty-text="暂无短链规则"
				><el-table-column label="归属分组" min-width="155" align="left" header-align="left"
					><template slot-scope="{ row }"
						><el-tag class="group-tag" effect="plain" :class="{ 'is-unassigned': !row.domain_group_id }" :style="groupTagStyle(row.domain_group_id)"><i class="el-icon-collection-tag" />{{ groupName(row.domain_group_id) }}</el-tag></template
					></el-table-column
				><el-table-column label="最终目标地址" min-width="300" show-overflow-tooltip
					><template slot-scope="{ row }"
						><span class="target-url">{{ row.target_url }}</span></template
					></el-table-column
				><el-table-column label="备注" prop="remark" min-width="180" show-overflow-tooltip /> ><el-table-column label="权重" width="110" align="center"
					><template slot-scope="{ row }"
						><span class="weight-tag"><i class="el-icon-data-analysis" />{{ row.weight }}</span></template
					></el-table-column
				><el-table-column label="当日 PV / UV" width="130"
					><template slot-scope="{ row }">{{ row.today_pv }} / {{ row.today_uv }}</template></el-table-column
				><el-table-column label="状态" width="118"
					><template slot-scope="{ row }"><el-switch v-model="row.state" :active-value="2" :inactive-value="1" @change="handleModifyStatus(row, $event)"/></template></el-table-column
				><el-table-column label="操作" width="120"
					><template slot-scope="{ row, $index }"><el-button type="text" size="mini" @click="handleEdit(row)">编辑</el-button><el-button type="text" size="mini" class="danger-button" @click="handleDelete(row, $index)">删除</el-button></template></el-table-column
				></el-table
			>
			<el-dialog :title="dialogStatus === 'create' ? '新增短链规则' : '编辑短链规则'" :visible.sync="dialogFormVisible" width="600px" custom-class="allocation-dialog"
				><div class="dialog-note"><i class="el-icon-sort" /> App 入口域名会在分组内轮询后台域名。权重越大，24 小时重置后获得的曝光比例越高。</div>
				<el-form ref="dataForm" :rules="rules" :model="temp" label-width="104px"
					><el-form-item label="跳转地址" prop="target_url"><el-input v-model.trim="temp.target_url" placeholder="请输入唯一的 http(s) 最终目标地址"/></el-form-item><el-form-item label="备注"><el-input v-model.trim="temp.remark" maxlength="255" show-word-limit placeholder="请输入备注"/></el-form-item
					><el-form-item label="归属分组" prop="domain_group_id"
						><el-select v-if="dialogStatus === 'create'" v-model="temp.domain_group_id" filterable placeholder="请选择分组" style="width:100%"><el-option v-for="item in groups" :key="item.id" :label="item.name" :value="item.id"/></el-select><el-input v-else :value="groupName(temp.domain_group_id)" disabled></el-input></el-form-item
					><el-form-item label="轮询权重" prop="weight"><el-input-number v-model="temp.weight" :min="1" :max="10000" controls-position="right" /><span class="form-help">数值越大，获得的访问比例越高</span></el-form-item
					><el-form-item label="过期时间"><el-date-picker v-model="temp.expires_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="留空表示永不过期"/></el-form-item
				></el-form>
				<div slot="footer"><el-button @click="dialogFormVisible = false">取消</el-button><el-button type="primary" @click="dialogStatus === 'create' ? createData() : updateData()">保存规则</el-button></div></el-dialog
			>
			<pagination v-if="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.pagesize" @pagination="getList" />
		</el-card>
	</div>
</template>
<script>
	import { groupTagStyle } from '@/utils/group-tag';

	export default {
		name: 'ShortLinkManager',
		data() {
			return { dialogStatus: '', dialogFormVisible: false, temp: {}, rules: { target_url: [{ required: true, message: '请输入最终目标地址', trigger: 'blur' }], domain_group_id: [{ required: true, message: '请选择分组', trigger: 'change' }], weight: [{ required: true, message: '请输入轮询权重', trigger: 'change' }] }, list: [], listLoading: true, groups: [], activatedOnce: false, listQuery: { page: 1, pagesize: 20, target_url: '', domain_group_id: '' }, total: 0 };
		},
		computed: {
			height() {
				return this.$baseTableHeight();
			}
		},
		created() {
			this.loadGroups();
			this.getList();
		},
		activated() {
			if (this.activatedOnce) this.loadGroups();
			this.activatedOnce = true;
		},
		methods: {
			groupTagStyle,
			loadGroups() {
				return this.request.get('/domain-group', { params: { state: 2 } }).then((data) => {
					this.groups = data.list || [];
				});
			},
			groupName(id) {
				const group = this.groups.find((item) => item.id === id);
				return group ? group.name : '未分组';
			},
			getList() {
				this.listLoading = true;
				this.request
					.get('/short-link', { params: this.listQuery })
					.then((data) => {
						this.total = data.count || 0;
						this.list = data.list || [];
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			resetTemp() {
				this.temp = { id: undefined, state: 2, target_url: '', remark: '', weight: 1, expires_at: '', domain_group_id: '' };
			},
			async handleEdit(row) {
				await this.loadGroups();
				this.resetTemp();
				if (row) {
					this.temp = Object.assign({}, this.temp, row);
					this.dialogStatus = 'update';
				} else this.dialogStatus = 'create';
				this.dialogFormVisible = true;
				this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate());
			},
			updateData() {
				this.$refs.dataForm.validate((valid) => {
					if (!valid) return;
					const payload = { id: this.temp.id, target_url: this.temp.target_url, remark: this.temp.remark || '', weight: this.temp.weight, expires_at: this.temp.expires_at };
					this.request.post('/short-link-edit', payload).then(() => {
						this.$message.success('规则已更新');
						this.dialogFormVisible = false;
						this.getList();
					});
				});
			},
			createData() {
				this.$refs.dataForm.validate((valid) => {
					if (!valid) return;
					this.request.post('/short-link-add', this.temp).then(() => {
						this.$message.success('规则已创建');
						this.dialogFormVisible = false;
						this.getList();
					});
				});
			},
			handleModifyStatus(row, state) {
				this.request
					.post('/short-link-edit', { id: row.id, state })
					.then(() => {
						this.$message.success('状态已更新');
					})
					.catch(() => {
						row.state = state === 2 ? 1 : 2;
					});
			},
			handleDelete(row, index) {
				this.$baseConfirm('删除后该规则将不再参与轮询，确定继续吗？', '删除规则', () =>
					this.request.post('/short-link-remove', row).then(() => {
						this.$message.success('删除成功');
						this.list.splice(index, 1);
						this.total -= 1;
					})
				);
			}
		}
	};
</script>
<style scoped>
	.short-link-page {
		padding-top: 18px;
	}
	.page-hero {
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		height: 96px;
		margin-bottom: 18px;
		padding: 14px 24px;
		border-radius: 14px;
		color: #fff;
		background: linear-gradient(120deg, #5a5c8d, #5c8396);
		box-shadow: 0 8px 18px rgba(76, 102, 143, 0.16);
	}
	.page-hero p {
		margin: 0 0 6px;
		color: rgba(255, 255, 255, 0.72);
		font-size: 10px;
		font-weight: 700;
		letter-spacing: 1.5px;
	}
	.page-hero h2 {
		margin: 0;
		font-size: 22px;
	}
	.page-hero span {
		display: inline-block;
		margin-top: 6px;
		color: rgba(255, 255, 255, 0.84);
		font-size: 13px;
	}
	.page-hero > i {
		padding: 11px;
		border: 1px solid rgba(255, 255, 255, 0.2);
		border-radius: 12px;
		background: rgba(255, 255, 255, 0.12);
		font-size: 24px;
	}
	.short-link-card {
		border: 0;
		border-radius: 12px;
		box-shadow: 0 5px 20px rgba(26, 45, 72, 0.08);
	}
	.content-heading {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 18px;
	}
	.content-heading h3 {
		margin: 0;
		color: #28364e;
		font-size: 18px;
	}
	.content-heading p {
		margin: 7px 0 0;
		color: #8592a5;
		font-size: 13px;
	}
	.filter-container {
		display: flex;
		gap: 10px;
		margin-bottom: 16px;
		padding: 14px;
		border-radius: 10px;
		background: #f7f9fd;
	}
	.filter-container .el-select,
	.filter-container .el-input {
		width: 210px;
	}
	.allocation-table {
		overflow: hidden;
		border: 1px solid #e8eff5;
		border-radius: 10px;
	}
	.allocation-table::v-deep td:first-child .cell,
	.allocation-table::v-deep th:first-child .cell {
		text-align: left;
	}
	.group-tag {
		display: inline-flex;
		align-items: center;
		max-width: 132px;
		height: 26px;
		padding: 0 10px;
		overflow: hidden;
		color: #39718e;
		border-color: #c9deea;
		border-radius: 13px;
		background: #f2f8fc;
		font-weight: 600;
		line-height: 24px;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.group-tag i {
		margin-right: 5px;
		color: inherit;
		font-size: 13px;
	}
	.group-tag.is-unassigned {
		color: #84909f !important;
		border-color: #e1e6eb !important;
		background: #f7f8fa !important;
	}
	.target-url {
		color: #285d80;
		font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
		font-size: 13px;
		font-weight: 650;
	}
	.weight-tag {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		padding: 4px 8px;
		color: #9a6b21;
		border-radius: 10px;
		background: #fff7e9;
		font-weight: 700;
	}
	.weight-tag i {
		color: #d59b39;
	}
	.form-help {
		margin-left: 10px;
		color: #95a0ae;
		font-size: 12px;
	}
	.danger-button {
		color: #d96868;
	}
	.dialog-note {
		margin-bottom: 20px;
		padding: 12px 14px;
		border-radius: 8px;
		color: #5c7186;
		background: #f4f8fc;
		font-size: 13px;
	}
	.dialog-note i {
		margin-right: 7px;
		color: #4a86a7;
	}
	.allocation-dialog .el-form-item {
		margin-bottom: 20px;
	}
	@media (max-width: 760px) {
		.filter-container {
			flex-wrap: wrap;
		}
		.filter-container .el-select,
		.filter-container .el-input {
			width: 100%;
		}
		.form-help {
			display: block;
			margin: 7px 0 0;
		}
	}
</style>
